const user = {
  username: 'VctorAHernandez',
  src: 'https://avatars3.githubusercontent.com/u/54184827?s=60&u=0dcec7f6973968e6df534754209b2eeae9968e0c&v=4',
  dateJoined: '2019-03-04T08:51:12',
  email: 'vhernandezcastro@gmail.com',
};

export default user;
